import Lottie from 'lottie-react';

import emptyLicenses from '../jsons/empty-licenses.json';

const EmptyLicenses = props => {
  return <Lottie loop={false} animationData={emptyLicenses} {...props} />;
};

export default EmptyLicenses;
